function loadVideo(element) {
  const elementWrapper = element.parentElement;

  window.addEventListener('resize', () => {
    elementWrapper.style.setProperty('--video-height', `${elementWrapper.clientHeight}px`);
  })

  elementWrapper.style.setProperty('--video-height', `${elementWrapper.clientHeight}px`);

  if (!shouldLoadVideo(element)) {
    document.addEventListener('scroll', onScrollHandler);
  } else {
    prepareVideo(element);
  }

  function onScrollHandler() {
    if (shouldLoadVideo(element)) {
      document.removeEventListener('scroll', onScrollHandler);

      prepareVideo(element);
    }
  }
}

function shouldLoadVideo(element) {
  const rect = element.getBoundingClientRect();
  const url = element.dataset.video;
  const isAutoplay = element.dataset.autoplay;
  const videoHeight = parseInt(element.parentElement.style.getPropertyValue('--video-height').replace('px', ''));

  if ((rect.bottom - rect.height <= (window.innerHeight || document.documentElement.clientHeight) + (videoHeight || 500)) || (rect.top + rect.height >= -(videoHeight || 500))) {

    const videoElement = document.createElement('video');
    const sourceElement = document.createElement('source');

    if (isAutoplay) {
      videoElement.muted = true;
      videoElement.playsInline = true;
    } else {
      videoElement.setAttribute('controls', true);
    }

    sourceElement.src = url;
    sourceElement.type = "video/mp4";

    videoElement.appendChild(sourceElement);

    element.appendChild(videoElement);

    return true;
  }

  return false;
}

function prepareVideo(element) {
  if (!isInViewport(element)) {
    document.addEventListener('scroll', onScrollHandler);
  } else {
    initAutoplay(element);
  }

  function onScrollHandler() {
    if (isInViewport(element)) {
      initAutoplay(element);
      document.removeEventListener('scroll', onScrollHandler)
    }
  }
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  const videoHeight = parseInt(element.parentElement.style.getPropertyValue('--video-height').replace('px', ''));

  return rect.bottom - rect.height <= ((window.innerHeight || document.documentElement.clientHeight) + (videoHeight * 0.7)) && rect.top + rect.height >= - (videoHeight * 0.7);
}

function initAutoplay(element) {
  if (!element.classList.contains('video-step2') && !element.classList.contains('video-step3')) {
    const playRepeat = element.dataset.playrepeat;
    const videoElement = element.querySelector('video');

    videoElement.addEventListener('play', () => {
      element.classList.remove('video-onClick');
    }, false);

    document.addEventListener('scroll', onScroll);

    switch (playRepeat) {
      case "once":
        videoElement.play();

        break;
      case "loop":
        const breakTime = element.dataset.breaktime;

        videoElement.play();
        videoElement.addEventListener('ended', loopHandler, false);

      function loopHandler() {
        setTimeout(function () {
          videoElement.play();
        }, breakTime * 1000);
      }

        break;
      default:
        break;
    }

    function onScroll() {
      if (!isInViewport(element)) {
        videoElement.pause();
        document.removeEventListener('scroll', onScroll);
        prepareVideo(element);
      }
    }
  }
}

export function initAutoplayVideo() {
  document.querySelectorAll('.autoplay-video').forEach(c => loadVideo(c));
}
